import React from 'react';
import PropTypes from 'prop-types';
import { getTranslations } from '@translations';
import AccountIconB2B from '@tamagoshi/core/cjs/iconsSystem/PersonOutline';
import CartIconB2B from '@tamagoshi/core/cjs/iconsSystem/ShoppingCart';
import FavoriteIconB2B from '@tamagoshi/core/cjs/iconsSystem/HeartBorder';
import CloseIcon from '@tamagoshi/icons/Close';

import AccountIconB2C from '@tamagoshi/icons/Person';
import CartIconB2C from '@tamagoshi/icons/ShoppingCart';

import cn from 'classnames';
import Icon from '../Icon';
import Button from '../Button';

import styles from './styles/index.module.scss';

const Navigation = ({
  icon,
  url,
  fill,
  size,
  tag,
  className,
  children,
  onClick,
  dataQaSelect,
  dataQaIcon,
  isAuthenticated,
  isB2B,
}) => {
  const translations = getTranslations();
  const iconClassName = cn({
    [styles.navigationIcon]: icon === 'list',
  });
  const iconContainerClassName = cn(className, styles.navigationItem, {
    [styles.burgerIcon]: icon === 'burgerMenu',
  });

  const AccountIcon = isB2B ? (
    <AccountIconB2B width="24" height="24" data-qa={dataQaIcon} />
  ) : (
    <AccountIconB2C viewBox={size} data-qa={dataQaIcon} />
  );

  const CartIcon = isB2B ? (
    <CartIconB2B width="24" height="24" />
  ) : (
    <CartIconB2C className={styles.navigationIconBasket} />
  );
  return (
    <div className={iconContainerClassName} data-qa={dataQaSelect}>
      <Button
        type="icon"
        tag={tag}
        href={url}
        className={styles.navigationTab}
        onClick={onClick}
      >
        {icon === 'account' && !isAuthenticated && (
          <div className={styles.connectItem}>
            {translations('header.subheader.account.login.button')}
          </div>
        )}
        {icon === 'account' && isAuthenticated ? AccountIcon : null}
        {icon === 'basket' ? CartIcon : null}
        {icon === 'list' && isB2B ? (
          <FavoriteIconB2B width="24" height="24" />
        ) : null}
        {icon === 'close' && (
          <CloseIcon className={styles.navigationIconClose} />
        )}

        {icon !== 'account' &&
          icon !== 'basket' &&
          icon !== 'close' &&
          icon !== 'list' && (
            <Icon
              size={size}
              id={icon}
              fill={fill}
              data-qa={dataQaIcon}
              className={iconClassName}
            />
          )}

        {children}
      </Button>
    </div>
  );
};

Navigation.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  tag: PropTypes.string.isRequired,
  fill: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  url: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  dataQaSelect: PropTypes.string,
  dataQaIcon: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  isB2B: PropTypes.bool,
};

Navigation.defaultProps = {
  url: undefined,
  className: undefined,
  children: null,
  onClick: () => {},
  fill: '#fff',
  size: 30,
  dataQaSelect: undefined,
  dataQaIcon: undefined,
  isAuthenticated: false,
  isB2B: false,
};

Navigation.displayName = 'Navigation';

export default Navigation;
